module.exports = __webpack_public_path__ + "static/yachtsafe-env1-cbf8787e8dbd38a1660002233c9e6779.jpg";